import { useState, useCallback } from 'react';
import { LearnHowPopup } from 'components/Popups/LearnHowPopup';
import { ShareTipsPopup } from 'components/Popups/ShareTipsPopup';
import { useSharePopup } from 'hooks/useSharePopup';
import {
  ABOUT_US_IMAGES,
  SHARE_TIPS_TEXT,
  SPOT_THE_GRIFT,
  FILTER_OUT_THE_SPAM,
  GIVE_ONLY_TO_TRUSTED,
  LEARN_HOW_MODAL,
} from './constants';

export const AboutUs = () => {
  const { openSharePopup, closeSharePopup, isPopupOpen, shareText } = useSharePopup();
  const [isLearnHowOpen, setIsLearnHowOpen] = useState(false);

  const openLearnHow = useCallback(() => setIsLearnHowOpen(true), []);
  const closeLearnHow = useCallback(() => setIsLearnHowOpen(false), []);

  return (
    <div className="about-us-container">
      <ShareTipsPopup isOpen={isPopupOpen} onClose={closeSharePopup} textToShare={shareText} />
      <LearnHowPopup isOpen={isLearnHowOpen} onClose={closeLearnHow} {...LEARN_HOW_MODAL} />
      <span className="h1-dtm">So What Can We Do?</span>
      <div className="about-us-feature">
        <div className="about-us-feature-image">
          <img src={ABOUT_US_IMAGES.spotTheGrift} alt="Spot the grift" />
        </div>
        <div className="about-us-feature-content">
          <span className="h2-dtm">{SPOT_THE_GRIFT.title}</span>
          <div className="h4-text about-us-spot-description">
            {SPOT_THE_GRIFT.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
            <ol>
              {SPOT_THE_GRIFT.listItems.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ol>
            <p>{SPOT_THE_GRIFT.closingParagraph}</p>
          </div>
          <button
            type="button"
            className="about-us-button"
            onClick={() => openSharePopup(SHARE_TIPS_TEXT)}
          >
            {SPOT_THE_GRIFT.buttonLabel}
          </button>
        </div>
      </div>

      <div className="about-us-feature about-us-feature--image-right">
        <div className="about-us-feature-content">
          <span className="h2-dtm">{FILTER_OUT_THE_SPAM.title}</span>
          <div className="h4-text about-us-spot-description">
            {FILTER_OUT_THE_SPAM.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <button type="button" className="about-us-button" onClick={openLearnHow}>
            {FILTER_OUT_THE_SPAM.buttonLabel}
          </button>
        </div>
        <div className="about-us-feature-image">
          <img src={ABOUT_US_IMAGES.filterSpam} alt="Filter out the spam" />
        </div>
      </div>

      <div className="about-us-feature">
        <div className="about-us-feature-image">
          <img src={ABOUT_US_IMAGES.trustedOrgs} alt="Give only to trusted orgs" />
        </div>
        <div className="about-us-feature-content">
          <span className="h2-dtm">{GIVE_ONLY_TO_TRUSTED.title}</span>
          <div className="h4-text about-us-spot-description">
            {GIVE_ONLY_TO_TRUSTED.description}
          </div>
          <a
            href={GIVE_ONLY_TO_TRUSTED.donateUrl}
            className="about-us-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            {GIVE_ONLY_TO_TRUSTED.buttonLabel}
          </a>
        </div>
      </div>

      <div className="about-us-press">{/* <BrandLogos title="In the Press" limit={5} /> */}</div>
    </div>
  );
};
